import Vue from "vue/dist/vue";

/**
 * Summernote component
 */
Vue.component('summernote', {
    props:     ['value'],
    template:  '#summernote-template',
    mounted:   function() {
        let vm = this;
        $(this.$el)
        // init select2
            .summernote($(this.$el).data('plugin-options'))
            .val(this.value)
            .trigger('change')
            // emit event on change.
            .on('change', function() {
                vm.$emit('input', this.value)
            })
    },
    watch:     {
        value: function(value) {
            // update value
            $(this.$el).val(value)
        },
    },
    destroyed: function() {
        $(this.$el).off().summernote('destroy')
    }
});



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/vue/summernote.js